var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveInStockAltIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_107_2",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_107_2",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACr0lEQVR4nO2du4oUQRSGP3dExEcwcjUQTBTMRPD2AGIgbKCbGJkvTiYiXhMN9AVkRdFoX0CMXF9gE9FMEEwEUy9T0tDCCjvSjPY5f3f9H5x0OPV/XdXVM0M1GGOMMcYYY4wxxhhTHweBVWANmFZSa8BlYBkhzgJvgVJ5bQJnMkUsAXcFgihCNQNut9mEYxnMFdNICV+mZgJXZBGtWfTy5XsGne4pIRwQuALLQCpk97UqMNAykLoUIWQqMNAykGqy6p0bAgMtA6kmKwshX4SFkB++hZAfeHVCngBHgT3/oe/mM44B6xaymIzrDP+iGs0MeQ9MehzDbuCDhXQX8oj+eWwh3YXcCxBy30K6C3kVIOS1heh8fX0u6OeD0dzUC/AFON9D/xfaz44Yw6iElG07rg3g5T/WRtDOavRCyoDLQsiXYCHkB28h5IdtIeQHbCHkh2oh5AdpIQLhFQvJD6xYSH5IxUL6CeEz8AB4CvwUCL/qJ/VvwOFtPa0APwT6qlbIux36UpRSjZCtOb1dBL4L9GcholKqnyFqUixETIqFiEmxEDEpFiImJUTIfuB4ch1ZoO+M55QQIUNmJfhrFgvpwEML0eKQhWixN/AUCi9ZHTjhGaLDBHhjIToy1se47T0pcJLblQVkPAuWESZE+fcQlZlhIYIyPEPEZFiImAwLEZNhIWjJqF7IRExGVUI+7iDjuUBf1QopwNW2n33AC4F+qhdSgE/AV4HgLYT8sC2E/IAthPxQLYT8IC1EILxiIfmBlTEI8VHjdBZyLUKID+NH6zB+v66CzkLCXha2KbA+F/Fq/t0SRnMeol95xFwZTTanCOaOwFVYROsmCSy1byPzTOGPmXEL2EUip31P4fc9I3yZ+hvL7TZv2p5MXUNN2zE3O09jjDHGGGOMMcYYY6iJX6S+yokgCYObAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveInStockAltIcon);
export default __webpack_public_path__ + "static/media/moveInStockAltIcon.29f143efbf54d58020f19afe28be5c48.svg";
export { ForwardRef as ReactComponent };